<template>
  <v-app>
    <v-app-bar
      app
      color="secondary"
    >
      <div class="d-flex align-center">

        <v-img
          :src="require('./assets/logo.svg')"
          contain
          height="40"
        ></v-img>
        <h2 color="primary">Title</h2>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-text-field
          label="Search"
          outlined
          dense
          hide-details
          append-icon="mdi-magnify"
        ></v-text-field>
      </div>
    </v-app-bar>
    <v-main>
      <v-toolbar dense color="primary">
        <v-btn text small color="secondary">
          Menu1
        </v-btn> 
        <v-btn text small color="secondary">
          Menu2
        </v-btn> 
        <v-spacer></v-spacer>
        <div class="user">
          <div class="user-text">
          <v-btn text color="secondary">User</v-btn>
          </div>
        </div>
      </v-toolbar>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step
            v-bind:color="saved ? 'green': 'primary'"
            :complete="e1 > 1"
            step="1"
          >Voyage</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            v-bind:color="saved ? 'green': 'primary'"
            :complete="e1 > 2"
            step="2"
          >Vessel</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            v-bind:color="saved ? 'green': 'primary'"
            :complete="e1 > 3"
            step="3"
          >Goods/Hazard Class</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step
            v-bind:color="saved ? 'green': 'primary'"
            :complete="saved"
            step="4"
          >Comments</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <Voyage ref="voyage"></Voyage>
            <v-btn
              color="primary"
              @click="saveVoyage"
            >Continue</v-btn>
            <v-btn
              text
              @click="reset"
            >reset</v-btn>
          </v-stepper-content>
          <v-stepper-content step="2">
            <Vessel ref="vessel"></Vessel>
            <v-btn
              color="primary"
              @click="saveVessel"
            >
              Continue
            </v-btn>

            <v-btn
              text
              @click="backVessel"
            >Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <Goods ref="goods"></Goods>
            <v-btn
              color="primary"
              @click="e1 = 4"
            >
              Continue
            </v-btn>

            <v-btn
              text
              @click="backGoods"
            >Back</v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <Comments ref="comments"></Comments>
            <v-btn
              color="primary"
              @click=save
            >
              Save
            </v-btn>

            <v-btn
            text
              @click="backComments"
            >Back</v-btn>
            <v-btn
            text
              @click="restart"
            >Restart</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-main>
    <v-footer color="primary">

    </v-footer>
  </v-app>
</template>

<style scoped>
.user {
  background-color: #219ee8;
  min-width: 100px;
  transform: skewX(-20deg);
  height: 100%;
}
.user-text {
  padding: 7px;
  transform: skewX(20deg);
}
</style>
<script>
export default {
  name: 'App',

  components: {
    Voyage: () => import("./components/Voyage.vue"),
    Vessel: () => import("./components/Vessel.vue"),
    Goods: () => import("./components/Goods.vue"),
    Comments: () => import("./components/Comments.vue")
  },

  data () {
    return {
        e1: 1,
        saved: false
      }
  },
  mounted() {
    let input = localStorage.getItem("ces-state")
    if (input) {
      console.log(input);
      this.$store.state.input = JSON.parse(input);
    }
  },
  methods: {
    cancel: function() {
      this.saved = false;
      this.e1 = 1;
    },
    reset: function() {
      this.saved = false;
      this.$store.state.input = {
        departure: "",
        destination: "",
        personsOnBoard: 0,
        fleet: undefined,
        vessel: undefined,
        vesselType: undefined,
        vesselName: "",
        vesselNo: "",
        length: undefined,
        width: undefined,
        draught: undefined,
        height: undefined,
        date: new Date().toISOString(),
        speed: undefined,
        tonnage: undefined,
        substance: "",
        amount: 0,
        classification: "",
        comment: ""
      }
      localStorage.setItem("ces-state", JSON.stringify(this.$store.state.input));
      this.$refs.voyage.resetValidation();
      this.e1 = 1;
    },
    restart: function() {
      this.saved = false;
      this.e1 = 1;
    },
    backVessel: function() {
      this.e1 -= 1;
      this.$refs.vessel.resetValidation();
    },
    backGoods: function() {
      this.e1 -= 1;
      this.$refs.goods.resetValidation();
    },
    backComments: function() {
      this.saved = false;
      this.e1 -= 1;
    },
    save: function() {
      this.saved = true;
      this.$refs.comments.save();
    },
    saveVoyage: function() {
      if (this.$refs.voyage.validate()) {
        this.$refs.voyage.save();
        this.e1 = 2;
      }
    },
    saveVessel: function() {
      if (this.$refs.vessel.validate()) {
        this.e1 = 3;
        this.$refs.vessel.save();
      }
    },
    saveGoods: function() {
      if (this.$refs.goods.validate()) {
        this.e1 = 4;
        this.$refs.goods.save();
      }
    },

  }
};
</script>
